export const routes = {
  signIn: '/',
  board: '/board',
};
